import { FC } from 'react'
import Step, { IStep } from './step'

interface IStepTable {
  stepsData: IStep[]
}

const StepTable: FC<IStepTable> = ({ stepsData }) => {
  return (
    <ul>
      {stepsData.map((item) => (
        <Step {...item} key={item.id} />
      ))}
    </ul>
  )
}

export default StepTable
